export const skills = [
  {
    id: 1,
    name: "Contract Drafting",
    author: "MaxEmployee",
    category: "Legal",
    rating: 4.7,
    sales: 342,
    approved: true,
    price: 29.90,
    description: "Automate the drafting of commercial, service, and employment contracts with intelligent templates.",
    tags: ["contracts", "legal", "automation", "drafting"],
    icon: "📝",
    steps: "User provides party data\nSystem selects the appropriate contract template\nSystem generates the complete contract with standard clauses\nUser reviews and customizes if needed\nSystem exports to PDF or DOCX",
  },
  {
    id: 2,
    name: "Procedural Deadline Management",
    author: "MaxEmployee",
    category: "Legal",
    rating: 4.6,
    sales: 215,
    approved: true,
    price: 19.90,
    description: "Automatic procedural deadline control with alerts, legal calendar, and court integration.",
    tags: ["deadlines", "processes", "legal", "alerts"],
    icon: "⚖️",
    steps: "User registers the process\nSystem identifies applicable deadlines\nSystem configures automatic alerts\nSystem sends notifications before due date",
  },
  {
    id: 3,
    name: "Dynamic FAQ",
    author: "MaxEmployee",
    category: "Support",
    rating: 4.3,
    sales: 580,
    approved: true,
    price: 0,
    description: "Create smart FAQs that learn from customer questions and automatically improve answers.",
    tags: ["faq", "support", "chatbot", "free"],
    icon: "💬",
    steps: "User defines frequently asked questions\nSystem creates automatic responses\nSystem analyzes customer questions\nSystem suggests improvements based on interactions",
  },
  {
    id: 4,
    name: "Bank Reconciliation",
    author: "MaxEmployee",
    category: "Financial",
    rating: 4.8,
    sales: 189,
    approved: true,
    price: 39.90,
    description: "Automatic bank statement reconciliation with discrepancy detection and financial reports.",
    tags: ["bank", "financial", "reconciliation", "statement"],
    icon: "🏦",
    steps: "User imports the bank statement\nSystem compares with accounting records\nSystem identifies discrepancies\nSystem generates reconciliation report",
  },
  {
    id: 5,
    name: "Commercial Proposals",
    author: "MaxEmployee",
    category: "Sales",
    rating: 4.5,
    sales: 267,
    approved: true,
    price: 24.90,
    description: "Generate professional commercial proposals in minutes with customizable templates and automatic value calculation.",
    tags: ["proposals", "sales", "commercial", "templates"],
    icon: "📊",
    steps: "User selects the proposal template\nUser enters client and service data\nSystem calculates values automatically\nSystem generates the proposal in PDF",
  },
  {
    id: 6,
    name: "Proactive Support",
    author: "Community",
    category: "Support",
    rating: 4.5,
    sales: 120,
    approved: true,
    price: 14.90,
    tags: ["support", "proactive", "chat"],
    description: "Automate proactive customer support with intelligent messages based on behavior.",
    steps: "Monitor behavior\nSend proactive message\nTrack response\nLog interaction",
  },
  {
    id: 7,
    name: "Agile Finance",
    author: "Community",
    category: "Financial",
    rating: 3.9,
    sales: 25,
    approved: true,
    price: 19.90,
    tags: ["financial", "agile", "management"],
    description: "Simplified financial management for small and medium businesses.",
    steps: "Register income\nRegister expenses\nGenerate reports",
  },
  {
    id: 8,
    name: "Direct Sales",
    author: "Community",
    category: "Sales",
    rating: 4.2,
    sales: 55,
    approved: true,
    price: 17.90,
    tags: ["sales", "direct", "crm"],
    description: "Direct sales system with pipeline and lead tracking.",
    steps: "Register leads\nQualify opportunities\nTrack pipeline\nClose sales",
  },
];

export const SKILLS_CATEGORIES = [
  { id: "Support", label: "Support", icon: "💬" },
  { id: "Legal", label: "Legal", icon: "⚖️" },
  { id: "Financial", label: "Financial", icon: "🏦" },
  { id: "Sales", label: "Sales", icon: "📊" },
  { id: "Health", label: "Health", icon: "❤️" },
  { id: "Marketing", label: "Marketing", icon: "📣" },
  { id: "Generic", label: "Generic", icon: "🧩" },
];

export const CATEGORY_COLORS = {
  Support: "#F59E0B",
  Legal: "#3B82F6",
  Financial: "#10B981",
  Sales: "#EF4444",
  Health: "#8B5CF6",
  Marketing: "#EC4899",
  Generic: "#6B7280",
};
